/** Main site script should go in this file. */

jQuery(document).ready(function() {
	
	// Set up SmartMenus
	setupNav();

});

// Initialize main navigation menu and menu behaviors
function setupNav() {

	jQuery('#main-menu__items').smartmenus({
		subIndicatorsPos: 'append',
		subMenusMinWidth: '100%',
		bottomToTopSubMenus: false
	});

	// Menu behaviors 
	var $mainMenuState = jQuery('#main-menu__state');
	if ($mainMenuState.length) {
		$mainMenuState.change(function(e) {
			var $menu = jQuery('#main-menu__items');
			if (this.checked) {
				$menu.hide().slideDown(250, function() { $menu.css('display', ''); });
			} else {
				$menu.show().slideUp(250, function() { $menu.css('display', ''); });
			}
		});
		// Hide mobile menu when window is unloaded 
		// (prevents the menu from being shown on refresh)
		jQuery(window).bind('beforeunload unload', function() {
			if ($mainMenuState[0].checked) {
				$mainMenuState[0].click();
			}
		});
	}
}

// Set Google Translate cookies and reload when clicking the language links
jQuery(document).ready(function($) {
	$(document).on('click','#lang-change-es', function() {
		Cookies.set('googtrans', '/en/es');
		location.reload();
	});

	$(document).on('click','#lang-change-en', function() {
		Cookies.set('googtrans', '/en');
		location.reload();
	});
});